// extracted by mini-css-extract-plugin
export default {"cardSettingsContainer":"style_cardSettingsContainer__GdHO6","wrapper":"style_wrapper__99uwK","listItem":"style_listItem__CS6Xk","saveButton":"style_saveButton__qJnlH"};